import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ResetPasswordPage() {
  const { t } = useTranslation();

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>{t('resetPassword.title')}</h1>
        <p className="login-subtitle">
          {t('resetPassword.subtitle')}
        </p>

        <a href="/auth/idprism/login" className="btn-primary" style={{ display: 'block', textAlign: 'center', width: '100%' }}>
          {t('common.signIn')}
        </a>

        <div className="login-links" style={{ textAlign: 'center' }}>
          <Link to="/login">{t('common.backToSignIn')}</Link>
        </div>
      </div>
    </div>
  );
}
